
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/campaign/[...campaign-pages]",
      function () {
        return require("private-next-pages/campaign/[...campaign-pages].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/campaign/[...campaign-pages]"])
      });
    }
  